import React from 'react';
import { FieldAttributes} from "formik";
import { BotaoFlat } from '../Botao/Botao';
import { useState } from 'react';
import { IoMdStarHalf } from 'react-icons/io';
import { AvaliacaoModal } from './AvaliacaoModal';
import { SolicitacaoDetalhada } from 'model/solicitacao/SolicitacaoDetalhada';
import { useCampoFormularioProps } from 'service/restricao/useCampoFormularioProps/useCampoFormularioProps';
import { AvaliacaoAction } from 'store/Avaliacao/Avaliacao.action';
import { useDispatch } from 'react-redux';


export interface IniciarAvaliacaoProps extends FieldAttributes<any> {
  solicitacao: SolicitacaoDetalhada;
}

export const AvaliacaoBotao: React.FunctionComponent<IniciarAvaliacaoProps> = ({solicitacao, ...props}) => {
  const restricoesProps = useCampoFormularioProps(props.name);
  const dispatch = useDispatch();
  
  const [isOpen, setIsOpen] = useState(false);
  const open = () => {
    setIsOpen(true);
    dispatch(AvaliacaoAction.formulario.iniciar());
  }
  const close = () => setIsOpen(false);


  if (restricoesProps.hidden)
    return <></>

  return <>
    <BotaoFlat
      type="button"
      tipo="success"
      onClick={open}>
      <IoMdStarHalf aria-hidden={true} />Avaliar ou Reabrir
    </BotaoFlat>
    
    <AvaliacaoModal isOpen={isOpen} solicitacao={solicitacao} onClose={close}/>
  </>
}